import React, { useState } from 'react';
import styles from './LongTermContract.module.scss';

const LongTermContract = () => {
  const [formData, setFormData] = useState({
    name: '',
    email: '',
    telephone: '',
    childrenCount: '',
    hoursPerWeek: '',
    message: '',
  });
  const [isSubmitting, setIsSubmitting] = useState(false);
  const [submissionStatus, setSubmissionStatus] = useState('');

  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormData((prevState) => ({
      ...prevState,
      [name]: value,
    }));
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    setIsSubmitting(true);
    setSubmissionStatus('');

    try {
      const response = await fetch('https://formspree.io/f/xanygezw', {
        method: 'POST',
        headers: {
          Accept: 'application/json',
          'Content-Type': 'application/json',
        },
        body: JSON.stringify({
          ...formData,
          formType: 'Demande de devis - contrat de longue durée',
          _subject: 'Nounou Chou Express — Demande de devis (contrat de longue durée)',
          _replyto: formData.email,
        }),
      });

      if (response.ok) {
        setSubmissionStatus('Votre demande de devis a été envoyée. Nous vous recontactons rapidement.');
        setFormData({
          name: '',
          email: '',
          telephone: '',
          childrenCount: '',
          hoursPerWeek: '',
          message: '',
        });
      } else {
        setSubmissionStatus('Une erreur est survenue. Veuillez réessayer.');
      }
    } catch (error) {
      console.error('Erreur lors de l\'envoi du devis:', error);
      setSubmissionStatus('Une erreur est survenue. Veuillez réessayer.');
    } finally {
      setIsSubmitting(false);
    }
  };

  return (
    <section className={styles.section} id="contrat-longue-duree">
      <div className={styles.container}>
        <h2>Contrats de longue durée</h2>
        <p className={styles.intro}>
          Besoin d'une garde régulière, sur plusieurs semaines ou toute l'année ?
          Nous établissons un devis personnalisé selon vos horaires, le nombre d'enfants
          et le rythme souhaité.
        </p>

        <div className={styles.layout}>
          <div className={styles.benefits}>
            <h3>Pour qui ?</h3>
            <ul>
              <li>Garde périscolaire plusieurs jours par semaine</li>
              <li>Garde à la journée sur une période définie</li>
              <li>Accompagnement régulier avant ou après l'école</li>
            </ul>
            <p>
              À partir de 16 heures de garde dans le mois, vous pouvez bénéficier du CMG
              et des avantages liés aux services à la personne.
            </p>
          </div>

          <form onSubmit={handleSubmit} className={styles.form}>
            <h3>Demande de devis</h3>
            <input
              type="text"
              name="name"
              placeholder="Nom et prénom"
              value={formData.name}
              onChange={handleChange}
              required
              className={styles.input}
            />
            <input
              type="email"
              name="email"
              placeholder="Email"
              value={formData.email}
              onChange={handleChange}
              required
              className={styles.input}
            />
            <input
              type="tel"
              name="telephone"
              placeholder="Téléphone"
              value={formData.telephone}
              onChange={handleChange}
              required
              className={styles.input}
            />
            <input
              type="number"
              name="childrenCount"
              placeholder="Nombre d'enfants"
              min="1"
              max="10"
              value={formData.childrenCount}
              onChange={handleChange}
              required
              className={styles.input}
            />
            <input
              type="text"
              name="hoursPerWeek"
              placeholder="Volume horaire souhaité (ex. 12 h / semaine)"
              value={formData.hoursPerWeek}
              onChange={handleChange}
              required
              className={styles.input}
            />
            <textarea
              name="message"
              placeholder="Décrivez vos besoins : jours, horaires, âge des enfants…"
              value={formData.message}
              onChange={handleChange}
              required
              className={styles.textarea}
            />
            <button type="submit" className={styles.button} disabled={isSubmitting}>
              {isSubmitting ? 'Envoi en cours…' : 'Demander un devis'}
            </button>
            {submissionStatus && <p className={styles.status}>{submissionStatus}</p>}
          </form>
        </div>
      </div>
    </section>
  );
};

export default LongTermContract;
